import { render } from "./EditAlertModal.vue?vue&type=template&id=22e197cc&scoped=true"
import script from "./EditAlertModal.vue?vue&type=script&lang=js"
export * from "./EditAlertModal.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css"
import "./EditAlertModal.vue?vue&type=style&index=1&id=22e197cc&scoped=true&lang=scss"

import exportComponent from "C:\\projects\\balkan-app-links\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22e197cc"]])

export default __exports__